import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import * as contentActions from "../../content/content.actions";
import { rem } from "polished";
import colors from "../../../utils/colors";

const Wrap = styled.ul`
  padding-top: 1rem;

  li {
    font-size: ${rem("12px")};
    display: inline-block;
    padding-right: 0.75rem;
    color: ${colors.GRAY};
  }
`;

const TagListArticle = props => {
  let { tags } = props;
  if (tags.length === 0) {
    tags.push("");
  }

  const getLink = tag => {
    return "/?filter=" + encodeURIComponent(tag);
  };

  //NOTE: start content load > home page not flickering
  const linkClick = tag => {
    const { getFilteredContents } = props;
    getFilteredContents([tag]);
  };

  return (
    <Wrap>
      {tags.map((tag, index) => (
        <NavLink to={getLink(tag)} key={index} onClick={() => linkClick(tag)}>
          <li>{tag !== "" ? "#" + tag : ""}</li>
        </NavLink>
      ))}
    </Wrap>
  );
};

const ConnectedTagListArticle = connect(null, contentActions)(TagListArticle);

export default ConnectedTagListArticle;



// WEBPACK FOOTER //
// ./src/modules/common/components/TagListArticle.js